import { RequestAccessScreen } from "@/screens/request-access";

/** Thin wrapper — toda lógica fica em screens/request-access */
export function RequestAccessPage() {
  return <RequestAccessScreen />;
}
